import { render } from "./devise.vue?vue&type=template&id=387c42f0&scoped=true"
import script from "./devise.vue?vue&type=script&lang=js"
export * from "./devise.vue?vue&type=script&lang=js"

import "./devise.vue?vue&type=style&index=0&id=387c42f0&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387c42f0"]])

export default __exports__